import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { I18NextService } from 'angular-i18next';
import { Angulartics2 } from 'angulartics2';
import { Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-header',
    styleUrls: ['./app-header.component.scss'],
    templateUrl: './app-header.component.html'
})
export class AppHeaderComponent implements OnInit {
    @Input()
    public navigationItems: Backend.PortalMenuFirstLevelMenuItem[];
    @ViewChild('menuDropdown', { static: true })
    public dropdown: NgbDropdown;

    public userName: string = ETR.currentUserLogin;
    public isAuthorized: boolean = !ETR.isAnonymous;
    public currentLanguage: string = '';
    public currentLanguageAlias: string = '';
    public vsmPortalUrl: string = '';
    public activeNavigationItem: Backend.PortalMenuFirstLevelMenuItem = null;
    public loginFromAnonymousPageUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private readonly loginFromAnonymousPageBaseUrl: string = 'home/loginFromAnonymousPage?redirectUrl=';

    constructor(private localeService: I18NextService, private angulartics2: Angulartics2, private router: Router) {
        this.currentLanguage = localeService.language.toUpperCase();
        this.currentLanguageAlias = this.currentLanguage === 'RU' ? 'Русский' : 'English';
        this.vsmPortalUrl = this.isAuthorized ? ETR.externalLinks.vsmPortalUrl : ETR.externalLinks.vsmPortalAnonymousUrl;
    }

    public ngOnInit(): void {
        this.router.events.pipe(filter((event: RouterEvent) => !!event.url)).subscribe((event: RouterEvent) => {
            if (event.url) {
                this.loginFromAnonymousPageUrl.next(this.loginFromAnonymousPageBaseUrl + event.url.toLowerCase());
            }
        });
    }

    public setLocale(locale: string): void {
        this.localeService.changeLanguage(locale).then(() => {
            window.location.reload();
        });
    }

    public setActiveNavigationItem(navigationItem: Backend.PortalMenuFirstLevelMenuItem): void {
        if (this.activeNavigationItem === navigationItem) {
            this.activeNavigationItem = null;
            this.dropdown.close();
        } else {
            this.activeNavigationItem = navigationItem;
            this.dropdown.open();
        }
    }

    public toggleMobileMenu(): void {
        document.documentElement.classList.toggle('menu-mobile-open');
    }

    public trackOutboundTransitionFromMenu(menuItemTitle: string): void {
        this.angulartics2.eventTrack.next({
            action: menuItemTitle,
            properties: {
                category: `Outbound transition from menu`
            }
        });
    }
}
